import axios from "axios";
import ConstantList from "app/appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/encounter";

export const getEncounter = (id) => {
  let url = API_PATH + "/" + id;
  return axios.get(url);
};

export const createEncounter = (obj) => {
  let url = API_PATH;
  return axios.post(url, obj);
};

export const editEncounter = (obj) => {
  let url = API_PATH + "/" + obj.id;
  return axios.put(url, obj);
};

export const deleteEncounter = (id) => {
  let url = API_PATH + "/" + id;
  return axios.delete(url);
};

export const checkEncounter = (obj) => {
  let url = API_PATH + "/checkEncounter";
  return axios.post(url, obj);
};

//new Encounter
export const getEtbEncounter = (id) => {
  let url = API_PATH + "/get-etb-encounter/" + id;
  return axios.get(url);
};

export const createEtbEncounter = (obj) => {
  let url = API_PATH + "/saveNew";
  return axios.post(url, obj);
};

export const editEtbEncounter = (obj) => {
  let url = API_PATH + "/saveNew/" + obj.id;
  return axios.put(url, obj);
};

export const createNewEtbEncounter = (patientId) => {
  let url = API_PATH + "/createNew/" + patientId;
  return axios.get(url);
}

export const checkEncounterEtb = (obj) => {
  let url = API_PATH + "/checkEncounterEtb";
  return axios.post(url, obj);
}

export const checkCustomRegimen = (obj) => {
  let url = API_PATH + "/check-is-custom-regimen";
  return axios.post(url, obj);
}

export const getOrderTestEtb = (obj) => {
  let url = API_PATH + "/getOrderTestEtb/" + obj.month + "/" + obj.shortTerm;
  return axios.get(url);
}

export const caculateTimeRegimenPhase = (obj) => {
  let url = API_PATH + "/caculateTimeRegimenPhase";
  return axios.post(url, obj);
}

export const checkEncounterDateEtb = (obj) => {
  let url = API_PATH + "/checkEncounterDateEtb";
  return axios.post(url, obj);
}

export const getStartDate = (obj) => {
  let url = API_PATH + "/getStartDate";
  return axios.post(url, obj);
}

export const getEtbLabTestItem = (obj) => {
  let url = API_PATH + "/get-etb-lab-test-item";
  return axios.post(url, obj);
}

export const pagingHistoryEncounter = (obj) => {
  let url = API_PATH + "/paging-history-encounter";
  return axios.post(url, obj);
}

export const getTypeResistanceByLabTest = (obj) => {
  let url = API_PATH + "/get-type-resistance-by-lab-test";
  return axios.post(url, obj);
}

export const accumulationOfTestsAndVisits = (obj) => {
  let url = API_PATH + "/accumulation-of-tests-and-visits";
  return axios.post(url, obj);
}

export const checkTreatmentMonth = (encounterSearchDto) => {
  // let formData = new FormData();
  // formData.append("patientId", patientId);
  // formData.append("month", month);
  var url = API_PATH + `/check-treament-month`;
  return axios.post(url, encounterSearchDto);
}

export const handleCheckDuplicateMedicationPhase = (obj) => {
  var url = API_PATH + `/check-duplicate-medications`;
  return axios.post(url, obj);
}
export const reloadPatientRegimen = (obj) => {
  var url = API_PATH + `/reloadPatientRegimen`;
  return axios.post(url, obj);
}
export const checkDuplicateMedicationHistory = (obj) => {
  var url = API_PATH + `/check-duplicate-medication-history`;
  return axios.post(url, obj);
}

export const checkCreatePeriod = (obj) => {
  let url = API_PATH + "/check-create-period";
  return axios.post(url, obj);
}

export const updateMedicationRequestDate = (obj) => {
  let url = API_PATH + "/update-medication-request-date";
  return axios.post(url, obj);
}

export const checkSaveHouseholdEncounter = (obj) => {
  let url = API_PATH + "/check-save-household-encounter";
  return axios.post(url, obj);
}

export const transferDrtbToDstb = (obj) => {
  let url = API_PATH + "/transfer-drtb-to-dstb";
  return axios.post(url, obj);
}
